<div class="flex h-full w-full flex-col" data-cy="menu-page">
	<!--
		Profile card. It sits where the app bar normally is and is why the bar is
		hidden here, so it keeps the bar's white ground and rounds only its bottom
		corners to read as the top of the screen rather than as a card floating on it.
	-->
	<!-- Dropped on desktop: the side menu already carries the name, حساب کاربری and خروج. -->
	<section
		class="flex shrink-0 flex-col items-center rounded-b-2xl bg-gray-000 px-4 py-3 md:hidden"
		aria-labelledby="menu-profile-name">
		<!-- The page is RTL, so the first child sits on the right: avatar and name lead, خروج trails. -->
		<div class="flex w-full items-center justify-between gap-2">
			<div class="flex min-w-0 items-center gap-1.5">
				<!-- No avatar image yet, so the generic person glyph stands in for one. -->
				<ui-icon
					class="shrink-0 text-gray-700"
					width="32"
					height="32"
					iconName="account"
					data-cy="menu-user-icon" />

				<div class="flex min-w-0 flex-col items-start justify-center">
					<p
						id="menu-profile-name"
						class="w-full truncate text-right text-sm font-bold text-gray-900"
						data-cy="menu-user-name">
						{{ userName() }}
					</p>

					<a
						class="flex items-center gap-0.5 text-xs font-medium text-blue-500"
						data-cy="menu-account-link"
						[routerLink]="accountRoute">
						<span>حساب کاربری</span>
						<ui-icon class="shrink-0 pt-1" width="18" height="18" iconName="chevron-left" />
					</a>
				</div>
			</div>

			<ui-button
				class="max-w-fit"
				extraButtonClasses="p-2 grow-0"
				variant="red"
				dir="ltr"
				model="outline"
				size="md"
				data-cy="menu-logout"
				label="خروج"
				(click)="onLogoutClick()">
				<ui-icon width="18" height="18" iconName="kala-logout" />
			</ui-button>
		</div>
	</section>

	<div class="flex min-h-0 flex-1 flex-col gap-2 overflow-y-auto">
		<!--
			Quick access. Four to a row, filled from the right — the fifth tile starts
			the next row on the right, as the handoff shows it.
		-->
		<nav class="grid grid-cols-4 gap-x-3 gap-y-4 rounded-2xl bg-gray-000 px-4 py-4" aria-label="دسترسی سریع">
			@for (tile of tiles; track tile.dataCy) {
				@if (tile.url) {
					<!--
						No target on mobile: a new tab would hand the installed PWA's link off to the
						browser. Desktop opens the tile's desktop site in a new tab.
					-->
					<a
						class="flex flex-col items-center justify-start gap-1"
						[href]="isDesktop() ? (tile.desktopUrl ?? tile.url) : tile.url"
						[attr.target]="isDesktop() ? '_blank' : null"
						[attr.rel]="isDesktop() ? 'noopener' : null"
						[attr.data-cy]="tile.dataCy">
						<ng-container *ngTemplateOutlet="tileBody; context: { $implicit: tile }" />
					</a>
				} @else {
					<a
						class="flex flex-col items-center justify-start gap-1"
						[routerLink]="tile.route"
						[attr.data-cy]="tile.dataCy">
						<ng-container *ngTemplateOutlet="tileBody; context: { $implicit: tile }" />
					</a>
				}
			}
		</nav>

		<ng-template #tileBody let-tile>
			<span class="flex size-14 items-center justify-center rounded-2xl bg-gray-050 {{ tile.iconClass }}">
				<ui-icon width="24" height="24" [iconName]="tile.icon" />
			</span>
			<span class="text-center text-2.75 min-[360px]:whitespace-nowrap font-medium text-gray-800">{{
				tile.title
			}}</span>
		</ng-template>

		<section class="flex flex-col rounded-2xl bg-gray-000 pt-4 pb-2" aria-labelledby="menu-general-title">
			<h2 id="menu-general-title" class="px-4 text-xs font-bold text-gray-900">عمومی</h2>

			<ul class="mt-2.5 flex flex-col px-4">
				@for (item of listItems; track item.title) {
					<li class="cursor-pointer not-first:border-t not-first:border-solid not-first:border-stroke-050">
						<a
							class="flex h-9 w-full items-center gap-2 text-3.25 font-medium text-gray-900"
							[routerLink]="item.route"
							[attr.data-cy]="item.dataCy"
							(click)="onListItemClick(item)">
							<ui-icon class="shrink-0 text-gray-950" width="20" height="20" [iconName]="item.icon" />
							<span class="min-w-0 flex-1 truncate text-right">{{ item.title }}</span>
							<ui-icon class="shrink-0 text-gray-500" width="20" height="20" iconName="chevron-left" />
						</a>
					</li>
				}
			</ul>
		</section>

		<!-- Dropped on desktop: the side menu carries the version and the refresh. -->
		<footer class="mt-auto flex shrink-0 items-center justify-between gap-2 px-4 py-3 md:hidden">
			<ui-button
				dir="rtl"
				type="button"
				variant="mute"
				size="md"
				class="w-full max-w-fit"
				extraButtonClasses="!grow-0 flex-row-reverse gap-1.5"
				data-cy="menu-get-latest-version"
				label="راه اندازی مجدد"
				[disabled]="checkingForUpdate()"
				[attr.aria-busy]="checkingForUpdate()"
				(click)="onGetLatestVersion()">
				<ui-icon height="18" width="18" iconName="sync" [class.animate-spin]="checkingForUpdate()" />
			</ui-button>

			<div class="flex min-w-0 flex-col items-start gap-0.5 text-gray-400" dir="ltr">
				<ui-icon width="60" height="15" viewBox="0 0 60 15" iconName="easy-kala-wordmark" />

				@if (versionLabel(); as label) {
					<p class="truncate text-2.75" data-cy="menu-app-version">{{ label }}</p>
				}
			</div>
		</footer>
	</div>
</div>

<app-logout-bottom-sheet #logoutSheet />
<app-social-links-bottom-sheet #socialSheet />
<app-support-bottom-sheet #supportSheet (chatbotSelected)="rocket()" />
